import { render, staticRenderFns } from "./ExternalGameTabExtra.vue?vue&type=template&id=394a4d8d&scoped=true&lang=pug"
import script from "./ExternalGameTabExtra.vue?vue&type=script&lang=js"
export * from "./ExternalGameTabExtra.vue?vue&type=script&lang=js"
import style0 from "./ExternalGameTabExtra.vue?vue&type=style&index=0&id=394a4d8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394a4d8d",
  null
  
)

export default component.exports